import { UNIDADES } from "@caint/data";
import { Header } from "@caint/design-system";
import { Fragment } from "react";
import {
  ApresentacaoCiclo,
  type ApresentacaoCicloProps,
} from "../components/apresentacao/ApresentacaoCiclo.tsx";

export type ApresentacaoProps = ApresentacaoCicloProps & { onBack: () => void };

/** Wrapper mobile da Apresentação do Ciclo — cabeçalho, botão PDF e o conteúdo. */
export function Apresentacao({ onBack, ...props }: ApresentacaoProps) {
  const ativa = UNIDADES.find((u) => u.id === props.avaliacaoAtual?.unidadeId);
  return (
    <Fragment>
      <Header title="Apresentação do Ciclo" sub={ativa?.nome ?? "Unidade"} onBack={onBack} />
      <div className="m-body">
        <div className="no-print" style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
          <button type="button" className="m-btn" onClick={() => window.print()}>
            🖨 Imprimir / PDF
          </button>
        </div>
        <ApresentacaoCiclo {...props} />
      </div>
    </Fragment>
  );
}
